import { Header, Logo, PageLayout } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

const LandingPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout align="center" width="narrow">
      <Logo />
      <Header level="h1">{t('page.welcome.title')}</Header>
    </PageLayout>
  );
};

export { LandingPage };
